import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UtilityService } from '@cots/common/services/utility.service';
import { Customer, CustomerQualityClause } from '@cots/customer/resources/customer';
import { CustomerService } from '@cots/customer/services/customer.service';

@Component({
  selector: 'customer-qc-editor',
  templateUrl: './customer-qc-editor.component.html',
  styleUrls: ['./customer-qc-editor.component.less']
})
export class CustomerQcEditorComponent implements OnInit {
  
  @Input() loading = true;
  @Output() loadingChange = new EventEmitter<boolean>();

  @Input() customer: Customer;
  
  @Input() editing = false;

  public selectedItem: CustomerQualityClause;
  
  public get isCreating() {
    return this.selectedItem && this.selectedItem.customerQualityClauseId === UtilityService.emptyGuid;
  }

  public get canSave() {
    return this.selectedItem && this.selectedItem.name;
  }

  constructor(private util: UtilityService, private service: CustomerService) { }

  ngOnInit(): void {
  }
  
  public createNewItem() {
    const item: CustomerQualityClause = {
      customerQualityClauseId: UtilityService.emptyGuid,
      customerId: this.customer.customerId,
      name: '',
      text: ''
    };
    this.setSelectedItem(item);
  }
  
  
  public resetForm() {
    if (this.itemForm && this.itemForm.form) {
      this.itemForm.form.markAsPristine();
      this.itemForm.form.markAsUntouched();
    }
  }
  
  private oldItemBackup: CustomerQualityClause | null;
  @ViewChild('itemForm') itemForm: NgForm;
  public async setSelectedItem(item: CustomerQualityClause) {
    if ((this.itemForm && this.itemForm.dirty) || (this.selectedItem && this.selectedItem.customerQualityClauseId) === UtilityService.emptyGuid) {
      const confirm = await this.util.showConfirmationPromise('Exit?', 'Are you sure you want to exit the current item? You will lose any unsaved changes.');
      if (!confirm) {
        return;
      } else {
        this.customer.qualityClauses[
          this.customer.qualityClauses.findIndex(x => x.customerQualityClauseId == this.selectedItem.customerQualityClauseId)
        ] = this.oldItemBackup;
      };
    }
    this.loading = true;
    this.selectedItem = item;
    this.oldItemBackup = JSON.parse(JSON.stringify(item));
    this.resetForm();
    this.loading = false;
  };

  public async saveSelected() {
    if (!this.selectedItem) return;
    this.loadingChange.emit(true);
    const isNew = this.selectedItem.customerQualityClauseId === UtilityService.emptyGuid;
    const item = await this.service.saveQualityClause(this.customer, this.selectedItem).toPromise();
    if (isNew) {
      this.customer.qualityClauses = [...this.customer.qualityClauses, item];
    }
    this.loadingChange.emit(false);
    this.customer.qualityClauses[
      this.customer.qualityClauses.findIndex(x => x.customerQualityClauseId == item.customerQualityClauseId)
    ] = item;
    this.selectedItem = item;
    this.resetForm();
  }

  public async deleteSelected() {
    if (!this.selectedItem) return;
    const deletedId = this.selectedItem.customerQualityClauseId;

    const confirm = await this.util.showConfirmationPromise('Delete Clause?', 'Are you sure? This cannot be undone.');

    if (!confirm) return;

    this.loadingChange.emit(true);

    await this.service.deleteQualityClause(this.selectedItem).toPromise();
    this.loadingChange.emit(false);
    this.customer.qualityClauses = this.customer.qualityClauses.filter(x => x.customerQualityClauseId !== deletedId);
    this.selectedItem = null;
  }
  

}
